
document.addEventListener("DOMContentLoaded", initPantsBundle);

async function initPantsBundle() {
  const products = await fetchBundleProducts();
  const selectedProducts = getRandomProducts(products, 3);

  const bundleContainer = document.querySelector("#pants-bundle-container");
  if (!bundleContainer) return;

  bundleContainer.innerHTML = "";

  selectedProducts.forEach((product, index) => {
    const productBox = document.createElement("div");
    productBox.className = "bundle-item";

    const title = document.createElement("div");
    title.className = "variant-title";
    title.innerText = product.title;

    const image = document.createElement("img");
    image.src = product.images?.[0] || '';
    image.alt = product.title;
    image.className = "variant-img";

    const variantSelect = document.createElement("select");
    variantSelect.className = "variant-selector";
    product.variants.forEach(variant => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.title;
      variantSelect.appendChild(option);
    });
    variantSelect.addEventListener("change", checkAllSelected);

    const productSelect = document.createElement("select");
    productSelect.className = "product-selector";
    products.forEach((p, i) => {
      const option = document.createElement("option");
      option.value = i;
      option.textContent = p.title;
      if (p.id === product.id) option.selected = true;
      productSelect.appendChild(option);
    });

    productSelect.addEventListener("change", (e) => {
      const selected = products[e.target.value];
      title.innerText = selected.title;
      image.src = selected.images?.[0] || '';
      image.alt = selected.title;
      variantSelect.innerHTML = "";
      selected.variants.forEach(variant => {
        const opt = document.createElement("option");
        opt.value = variant.id;
        opt.textContent = variant.title;
        variantSelect.appendChild(opt);
      });
      checkAllSelected();
    });

    productBox.appendChild(title);
    productBox.appendChild(image);
    productBox.appendChild(variantSelect);
    productBox.appendChild(productSelect);
    bundleContainer.appendChild(productBox);
  });

  renderAddToCartButton(bundleContainer);
}

async function fetchBundleProducts() {
  try {
    const res = await fetch("/collections/pants-bundle/products.json");
    const data = await res.json();
    const products = data.products;

    const fullProducts = await Promise.all(
      products.map(async (p) => {
        const res = await fetch(`/products/${p.handle}.js`);
        const product = await res.json();
        return product;
      })
    );

    return fullProducts;
  } catch (err) {
    console.error("❌ Failed to load pants bundle:", err);
    return [];
  }
}

function getRandomProducts(products, count) {
  const shuffled = [...products].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

function renderAddToCartButton(container) {
  const button = document.createElement("button");
  button.textContent = "Add Bundle to Cart";
  button.className = "add-to-cart-bundle";
  button.id = "add-bundle-to-cart";
  button.disabled = true;

  button.addEventListener("click", async () => {
    const selectors = Array.from(document.querySelectorAll('.variant-selector'))
      .filter(sel => sel.value && sel.value !== "")
      .slice(0, 3);

    for (let sel of selectors) {
      const variantId = sel.value;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity: 1, id: variantId })
      });
    }

    window.location.href = '/cart';
  });

  container.appendChild(button);
}

function checkAllSelected() {
  const allSelectors = Array.from(document.querySelectorAll('.variant-selector'));
  const filled = allSelectors.filter(sel => sel.value && sel.value !== "");
  const button = document.getElementById('add-bundle-to-cart');
  if (button) {
    button.disabled = filled.length !== 3;
  }
}
